NotificationHelper = LP.module 'NotificationHelper'

MySavedSearches = LP.module 'MySavedSearches'

MySavedSearches.index = ->
  @updateDeleteSelectedButtonState()

  $('#select-all').change ->
    $('.saved-search-select').prop('checked', $(@).is(':checked'))
    MySavedSearches.updateDeleteSelectedButtonState()
    return

  $('.saved-search-select').change ->
    MySavedSearches.updateDeleteSelectedButtonState()
    return

MySavedSearches.updateDeleteSelectedButtonState = ->
  disabled = !$('.saved-search-select').is(':checked')
  $('#delete-saved-searches').prop('disabled', disabled)
  $('#delete-saved-searches').toggleClass('disabled', disabled)